// src/components/EmptyWishlistPage.tsx

import React from 'react';

// Icon representing the Wishlist (a large, stylized heart)
const HeartIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    // Use a light, neutral color for the empty state icon
    className="w-28 h-28 sm:w-32 sm:h-32 text-gray-300 fill-gray-100" 
  >
    {/* Heart shape */}
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);


const WishlistPage: React.FC = () => {
  return (
    // Outer container for centering content and setting page background
    <div className="flex items-start justify-center min-h-screen bg-gray-50 pt-16 sm:pt-24 md:pt-32">
      
      {/* The main content box, centered and shadowed */}
      <div className="flex flex-col items-center max-w-lg p-8 text-center bg-white rounded-lg">
        
       {/* 1. Illustration/Image */}
<div className="p-4 flex justify-center mt-[-100px]">
  <img
    src="https://media.istockphoto.com/id/1816661135/vector/online-retailer-abstract-concept-vector-illustration-set-online-shopping-wishlist-buy.jpg?s=612x612&w=0&k=20&c=y-QfrPOVUrWY4d6R6nzPQ142q5cSLqKna16d9gnIE2E="
    alt="Empty Wishlist"
    className="w-72 md:w-96 lg:w-[420px] object-contain "
  />
</div>

        {/* 2. Main Message */}
        <h2 className="text-xl sm:text-2xl font-semibold text-gray-700 mb-4">
          Your Wishlist is Empty!
        </h2>

        {/* 3. Sub Text / Explanation */}
        <p className="text-base text-gray-500 mb-8 max-w-md">
          Looks like you haven't saved any items yet. Add items you love to keep track of them here!
        </p>

        {/* 4. Call-to-Action Button */}
        <a 
          href="/" // Replace with your actual product or shopping page route
          className="
            inline-flex 
            items-center 
            justify-center 
            px-12 py-3 
            text-base font-medium 
            rounded-md 
            text-white 
            bg-[#a5885c] hover:bg-[#8e7552] focus:outline-none 
            focus:ring-2 focus:ring-offset-2 focus:ring-[#a5885c]
            transition duration-150 ease-in-out
          "
        >
          Start Browsing
        </a>
      </div>
    </div>
  );
};

export default WishlistPage;